
export const LG = "(max-width: 1024px)";
export const XL = "(max-width: 1200px)";